<script setup>
import { useRoute } from '@js/utils/route';

const { tenant, aiProductContent, callback } = defineProps({
    tenant: {
        type: Object,
        required: true,
    },
    aiProductContent: {
        type: Object,
        required: true,
    },
    callback: {
        type: Function,
        required: false,
    },
});

const { route } = useRoute();

function action() {
    axios
        .post(
            route(
                'front.projectManagement.ai.postToggleProductContentValidatedAt',
                {
                    tenant: tenant.id,
                    aiProductContent: aiProductContent.id,
                },
            ),
        )
        .then(() => {
            if (callback) {
                callback();
            }
        })
        .catch((error) => {
            console.error(error);
        });
}
</script>

<template>
    <slot name="button" :action="action" />
</template>
